import clsx from 'clsx';
import React from 'react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import LockIcon from '../../assets/icons/red-lock-icon.svg?react';

interface ChangePasswordModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  otherClasses,
  handleClose,
  formHandler,
}) => {
  const changePasswordModalClasses = clsx(otherClasses);
  const sm = useButtonSizeSmall();

  return (
    <div
      className={changePasswordModalClasses}
      data-testid="change-password-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <LockIcon className="h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">Change Password</h4>
        <p className="text-brand-posh-pink font-inter-variable text-lg leading-5 font-normal">
          Enter current password and new password.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <Input
          onBlur={formHandler?.handleBlur}
          label="Current Password*"
          errorMessage={
            formHandler?.touched.currentPassword &&
            formHandler?.errors.currentPassword
              ? formHandler?.errors.currentPassword
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.currentPassword}
          type="password"
          placeholder="Current password"
          onChange={formHandler?.handleChange}
          name="currentPassword"
          otherClasses={{ container: 'w-full mb-6' }}
          aria-required={true}
          aria-invalid={
            formHandler?.touched.currentPassword &&
            !!formHandler?.errors.currentPassword
          }
          aria-describedby={
            formHandler?.touched.currentPassword &&
            formHandler?.errors.currentPassword
              ? 'password-error'
              : undefined
          }
        />
        <Input
          onBlur={formHandler?.handleBlur}
          label="New Password*"
          errorMessage={
            formHandler?.touched.password && formHandler?.errors.password
              ? formHandler?.errors.password
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.password}
          type="password"
          placeholder="New password"
          onChange={formHandler?.handleChange}
          name="password"
          otherClasses={{ container: 'w-full mb-6' }}
          aria-required={true}
          aria-invalid={
            formHandler?.touched.password && !!formHandler?.errors.password
          }
          aria-describedby={
            formHandler?.touched.password && formHandler?.errors.password
              ? 'password-error'
              : undefined
          }
        />
        <Input
          onBlur={formHandler?.handleBlur}
          label="Retype New Password*"
          errorMessage={
            formHandler?.touched.confirmPassword &&
            formHandler?.errors.confirmPassword
              ? formHandler?.errors.confirmPassword
              : ''
          }
          disabled={formHandler?.isSubmitting}
          value={formHandler?.values.confirmPassword}
          type="password"
          placeholder="Retype password"
          onChange={formHandler?.handleChange}
          name="confirmPassword"
          otherClasses={{ container: 'w-full' }}
          aria-required={true}
          aria-invalid={
            formHandler?.touched.confirmPassword &&
            !!formHandler?.errors.confirmPassword
          }
          aria-describedby={
            formHandler?.touched.confirmPassword &&
            formHandler?.errors.confirmPassword
              ? 'confirm-password-error'
              : undefined
          }
        />
        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={sm}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            otherClasses="bg-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
            size={sm}
            disable={formHandler?.isSubmitting}
          >
            Change Password
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ChangePasswordModal;
